<template>
  <div class="avatar-container" :style="style" aria-hidden="true">
    {{ userInitial }}
  </div>
</template>

<script>
// Paleta de gradientes do protótipo (135deg) — sorteada por nome, texto branco
const AVATAR_GRADIENTS = [
  ['#7fc7f5', '#4f9de8'], // azul
  ['#8fd7a0', '#5cbf7a'], // verde
  ['#a89ef0', '#7a5cf0'], // roxo
  ['#f0a9c8', '#e06fa0'], // rosa
  ['#f5a97f', '#e8804f'], // laranja
  ['#ffb56b', '#f78e3d'], // âmbar
];

export default {
  name: 'Avatar',
  props: {
    username: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 40,
    },
  },
  computed: {
    // Hash determinístico do nome → sempre a mesma cor para o mesmo contato
    gradient() {
      const name = this.username || '';
      let hash = 0;
      for (let i = 0; i < name.length; i += 1) {
        hash = (hash * 31 + name.charCodeAt(i)) % 1000000007;
      }
      const index = Math.abs(hash) % AVATAR_GRADIENTS.length;
      const [from, to] = AVATAR_GRADIENTS[index];
      return `linear-gradient(135deg, ${from}, ${to})`;
    },
    style() {
      return {
        fontSize: `${Math.floor(this.size / 2.5)}px`,
        backgroundImage: this.gradient,
        color: '#fff',
      };
    },
    userInitial() {
      const parts = this.username.split(/[ -]/);
      let initials = parts.reduce((acc, curr) => acc + curr.charAt(0), '');

      if (initials.length > 2 && initials.search(/[A-Z]/) !== -1) {
        initials = initials.replace(/[a-z]+/g, '');
      }
      initials = initials.substring(0, 2).toUpperCase();

      return initials;
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-container {
  display: flex;
  line-height: 100%;
  font-weight: 700;
  align-items: center;
  justify-content: center;
  text-align: center;
  // fundo (gradiente sorteado) e cor vêm do :style inline no template
  cursor: default;
}
</style>
